export const RouletteService = {
    /**
   * Return color class of roulette grid item
   * @param resultNumber
   * @return {string}
   */
    getRouletteResultColorClass(resultNumber) {
        resultNumber = parseInt(resultNumber, 10);

        // zero - always green
        if (resultNumber === 0) {
            return 'roulette-result__item--green';
        }

        // In number ranges from 1 to 10 and 19 to 28, odd numbers are red and even are black.
        if (((resultNumber >= 1 && resultNumber <= 10) || (resultNumber >= 19 && resultNumber <= 28))) {
            if (resultNumber % 2 === 0) {
                return '';
            } else {
                return 'roulette-result__item--red';
            }
        }

        // In ranges from 11 to 18 and 29 to 36, odd numbers are black and even are red.
        if (((resultNumber >= 11 && resultNumber <= 18) || (resultNumber >= 29 && resultNumber <= 36))) {
            if (resultNumber % 2 === 0) {
                return 'roulette-result__item--red';
            } else {
                return '';
            }
        }

        return '';
    }
};
